import { ActiveRecord, sources } from '@mysidewalk/active-record';
import LayerReference from '../features/LayerReference.js';
import LayerRecord from '../features/LayerRecord.js';
/**
 * @memberof system-metadata
 * @property {number} id
 * @property {number} order
 * @property {string} friendlyLongName
 * @property {string} friendlyShortName
 * @property {string} pluralLongName
 * @property {date} loadedAt
 * @property {string} sourceObject
 * @property {string} sourceSchema
 * @property {string} sourceTable
 * @property {string} systemName
 * @property {system-metadata.Attribution} attribution
 * @property {system-metadata.FeatureClassDetail} detail
 */
class FeatureClass extends ActiveRecord {
    initialize(props) {
        super.initialize(props);
        this.pluralLongName = PLURAL_FRIENDLY_LONG_NAMES[this.friendlyLongName] || (`${this.friendlyLongName}s`);
    }
    /**
     * @return {feature-references.LayerReference}
     */
    toLayerReference() {
        return new LayerReference({
            sourceId: this.id,
            type: LayerReference.SourceType.SYSTEM,
        });
    }
    /**
     * @return {feature-references.LayerRecord}
     */
    toLayerRecord() {
        return new LayerRecord({
            ref: this.toLayerReference(),
            label: this.pluralLongName,
        });
    }
}
FeatureClass.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
};
const PLURAL_FRIENDLY_LONG_NAMES = {
    County: 'Counties',
};
export default FeatureClass;
